(() => {
 'use strict';
 if(customElements.get('muymo-whatsapp-consent'))return;
 const text='Recibir por Whatsapp avisos de mis pedidos y recordatorios de carritos.';
 const key='muymo_whatsapp_consent';
 let current=null,writing=Promise.resolve(),pending=0;
 const nodes=()=>[...document.querySelectorAll('muymo-whatsapp-consent')];
 function initial(raw){try{const v=JSON.parse(raw),age=Date.now()-Date.parse(v.at);return v.version==='muymo-cart-v1'&&v.text===text&&v.accepted===true&&age>=-30000&&age<86400000?v:null;}catch{return null;}}
 function render(message=''){
  for(const el of nodes()){
   el.querySelector('[data-wa-choice]').checked=current?.accepted===true;
   el.querySelector('[data-wa-attribute]').value=JSON.stringify(current||{version:'muymo-cart-v1',accepted:false,text,at:new Date().toISOString()});
   el.querySelector('[data-wa-status]').textContent=message;
  }
 }
 function save(){
  const value=JSON.stringify(current);pending++;
  render('Guardando tu elección…');
  writing=writing.catch(()=>{}).then(async()=>{
   const root=window.Shopify?.routes?.root||'/';
   const r=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{[key]:value}}),signal:AbortSignal.timeout(10000)});
   if(!r.ok)throw Error('No se pudo guardar');
   const cart=await r.json();if(cart.attributes?.[key]!==value)throw Error('No se confirmó');
  }).then(()=>{pending--;if(!pending)render('');},()=>{pending--;if(!pending)render('Tu elección se guardará al continuar con la compra.');});
 }
 class Consent extends HTMLElement{
  connectedCallback(){
   if(this.dataset.ready)return;this.dataset.ready='true';
   if(current===null)current=initial(this.dataset.saved)||{version:'muymo-cart-v1',accepted:false,text,at:new Date().toISOString()};
   this.hidden=false;
   this.querySelector('[data-wa-choice]').addEventListener('change',e=>{
    current={version:'muymo-cart-v1',accepted:e.target.checked,text,at:new Date().toISOString()};render();save();
   });
   render();
  }
 }
 customElements.define('muymo-whatsapp-consent',Consent);
 // Finish queued attribute writes before the ordinary Shopify form submission.
 // Hidden form fields also persist the last choice if the Ajax request failed.
 const resuming=new WeakSet(),waiting=new WeakSet();
 document.addEventListener('submit',async e=>{
  const form=e.target;
  if(!(form instanceof HTMLFormElement)||resuming.has(form)||!nodes().some(n=>n.dataset.form===form.id)||!pending)return;
  e.preventDefault();e.stopImmediatePropagation();
  if(waiting.has(form))return;waiting.add(form);
  const submitter=e.submitter;
  while(pending)await writing;render();
  // Cart section refreshes can replace the original checkout button.
  const activeForm=form.isConnected?form:document.getElementById(form.id);
  const activeSubmitter=submitter?.isConnected&&submitter.form===activeForm?submitter:
   [...document.querySelectorAll('button[name="checkout"],input[name="checkout"]')].find(b=>b.form===activeForm);
  if(!activeForm||!activeSubmitter){waiting.delete(form);render('Tu elección está guardada. Tocá Continuar para seguir.');return;}
  resuming.add(activeForm);
  try{activeForm.requestSubmit(activeSubmitter);}finally{resuming.delete(activeForm);waiting.delete(form);}
 },true);
})();
